module.exports = __webpack_public_path__ + "img/radio.506577b6.svg";